import { PostEssentialPlanSuccessAction, PostEssentialPlanFailureAction } from './essentials.types';

export const postEssentialPlanSuccess = (): PostEssentialPlanSuccessAction => ({
  type: 'POST_ESSENTIAL_PLAN_SUCCESS'
});

export const postEssentialPlanFailure = (payload: string): PostEssentialPlanFailureAction => ({
  type: 'POST_ESSENTIAL_PLAN_FAILURE',
  payload
});
